






import {Vue, Component} from 'vue-property-decorator';
import {ncpPopup} from '@/utils/ncp';

type AlertText = 'batchConfirm';

@Component
export default class JudgementListSlotLeft extends Vue {
  private tuiGridContainer: any;

  private onClickBatchJudgment() {
    const productNos = this.tuiGridContainer.getCheckedItems('productNo') as string;
    const applyStatusType = this.tuiGridContainer.getCheckedItems('applyStatus') as string;
    if (!productNos) {
      alert(this.$t('PRODUCT_PRODUCT_SELECT_PRODUCT'));
      return;
    }
    const mallProductNosArr = productNos.split(',');
    const nos: string[] = [];
    const targetStatus = ['APPROVAL_READY', 'AFTER_APPROVAL_READY'];
    applyStatusType.split(',').forEach((item, idx): void => {
      if (targetStatus.includes(item)) {
        nos.push(mallProductNosArr[idx]);
      }
    });

    if (nos.length) {
      ncpPopup(`/product/judgement/batchConfirm/${nos.join(',')}`, 'batchJudgment', 800, 450);
    } else {
      alert(this.$t('PRODUCT_PRODUCT_SELECT_JUDGE_DISABLE'));
    }
  }

  private mounted() {
    this.tuiGridContainer = this.$parent;
  }
}
